import React from 'react'
import PropTypes from 'prop-types'
import ServiceRow from './ServiceRow'
import { EXETEL_URL, mapServiceTypeToTitle } from '../constants'
import UsageRow from './UsageRow'
import CustomLink from './CustomLink'
import { useMedia } from 'react-use'

const ServiceRowHomeSecure = (props) => {
    const isMobile = useMedia('(max-width: 992px)')

    const getThreatSummary = () => {
        if (props.item.threatProtectionEnabled) {
            return `${props.item.threatsBlocked.total} (last 30 days)`
        }

        return <CustomLink to={`/my-services/home-secure/${props.item.broadbandServiceId}/threat-protection`} className='color-grey'>Turn on protection</CustomLink>
    }

    const getParentalControlSummary = () => {
        if (props.item.parentalControlEnabled) {
            return `${props.item.blockedContent.total} (last 30 days)`
        }

        return <CustomLink to={`/my-services/home-secure/${props.item.broadbandServiceId}/parental-control`} className='color-grey'>Turn on filtering</CustomLink>
    }

    const getSecurityLevel = () => {
        if (props.item.securityLevel < 60) return 'Low'
        if (props.item.securityLevel < 80) return 'Medium'

        return 'High'
    }

    const LearnMore = <CustomLink to={`${EXETEL_URL}/broadband/nbn/home-secure`} className='color-grey gtm-hs-dashboard-what-is-this underline'>Learn more</CustomLink>
    const Cancelled = <span className='color-red'>Cancelled on {props.item.subscriptionEnds}</span>

    return (
        <ServiceRow
            icon='/images/home-secure/home-secure-logo.svg'
            title={mapServiceTypeToTitle[props.item.type]}
            preTitle={props.item.isTrial ? <span className='bold'>FREE TRIAL</span> : 'Network level protection'}
            subTitle={props.item.isCancelled ? Cancelled : LearnMore}
            url={`/my-services/home-secure/${props.item.broadbandServiceId}`}
            isSubService
        >
            {!isMobile
                ? <React.Fragment>
                    <UsageRow
                        title='Security level'
                        isUnlimitedUsage={false}
                        progress={props.item.securityLevel}
                        summaryText={getSecurityLevel()}
                        hideProgress
                        itemKey='security'
                    />
                    <UsageRow
                        title='Threats blocked'
                        isUnlimitedUsage
                        showUnlimitedUsage
                        summaryText={getThreatSummary()}
                    />
                    <UsageRow
                        title='Blocked content'
                        isUnlimitedUsage
                        showUnlimitedUsage
                        summaryText={getParentalControlSummary()}
                        isLastItem
                    />
                </React.Fragment>
                : ''}
        </ServiceRow>
    )
}

ServiceRowHomeSecure.propTypes = {
    item: PropTypes.shape({
        broadbandServiceId: PropTypes.number,
        type: PropTypes.string,
        isTrial: PropTypes.bool,
        securityLevel: PropTypes.number,
        threatsBlocked: PropTypes.object,
        blockedContent: PropTypes.object
    }).isRequired
}

export default ServiceRowHomeSecure



// WEBPACK FOOTER //
// ./resources/js/components/ServiceRowHomeSecure.js